export default __webpack_public_path__ + "static/El_choclo-c115b1aa8feca54674dcb6f76c55ce6e.mp3";